/**
 * i18n çekirdeği — yalnızca Türkçe paketleri senkron yüklenir (en/ru ayrı chunk).
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import trCommon from './locales/tr/common.json'
import trHome from './locales/tr/home.json'
import trPortfolio from './locales/tr/portfolio.json'
import trAbout from './locales/tr/about.json'
import trContact from './locales/tr/contact.json'
import trSiteLayout from './locales/tr/siteLayout.json'
import trValidation from './locales/tr/validation.json'

export const i18nInitPromise = i18n.use(initReactI18next).init({
  resources: {
    tr: {
      common: trCommon,
      home: trHome,
      portfolio: trPortfolio,
      about: trAbout,
      contact: trContact,
      siteLayout: trSiteLayout,
      validation: trValidation,
    },
  },
  lng: 'tr',
  fallbackLng: 'en',
  ns: ['common', 'home', 'portfolio', 'about', 'contact', 'siteLayout', 'validation'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
  partialBundledLanguages: true,
  react: {
    useSuspense: false,
    bindI18nStore: 'added removed',
  },
})

export default i18n
